class SHDropdown extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector(".dropdown-header");
    this.content = this.querySelector(".dropdown-content");
    this.input = this.header.querySelector("input");
    this.options = this.content.querySelectorAll(".option");
    this.context = this.input.dataset.context;

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    this.header.addEventListener("click", this.onHeaderClick.bind(this));
    Array.from(this.options).forEach((option) => {
      option.addEventListener("click", this.setOption.bind(this, option));
    });
  }

  setOption(option, event) {
    event.preventDefault();
    if (
      !option.classList.contains("unavailable") &&
      this.input.value !== option.dataset.label
    ) {
      this.input.value = option.dataset.label;
      this.input.classList.add("filled");
      const selectedOption = option.parentNode.querySelector(".selected");
      selectedOption && selectedOption.classList.remove("selected");
      option.classList.add("selected");
      this.sendEvent(option);
    }
    this.close();
  }

  sendEvent(option) {
    switch (this.input.dataset.context) {
      case "variant":
        publish(PUB_SUB_EVENTS.variantChange, {
          option_id: option.dataset.id,
          option_label: option.dataset.label,
          option_handle: option.dataset.value,
        });
        break;

      case "sorting":
        publish(PUB_SUB_EVENTS.sortingChange, {
          option_id: "sort_by",
          option_label: option.dataset.label,
          option_value: option.dataset.value,
          option_default: this.input.dataset.default,
        });
        break;

      default:
        break;
    }
  }

  onHeaderClick(event) {
    event.preventDefault();
    if (!this.hasAttribute("open")) {
      this.open();
    } else {
      this.close();
    }
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.header && !target.closest("sh-dropdown")) this.close();
  }

  open() {
    this.setAttribute("open", true);
    const contentRect = this.content.getBoundingClientRect();
    const withinModal = this.closest(".dialog-content");
    const limitBorder = withinModal
      ? withinModal.getBoundingClientRect().bottom
      : window.innerHeight;
    if (contentRect.bottom + 16 > limitBorder) {
      const dY = limitBorder - contentRect.bottom - 16;
      this.content.style.transform = `translateY(${dY}px)`;
    }
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.removeAttribute("open");
    this.content.style.transform = "";
    document.body.removeEventListener("click", this.onBodyClick);
  }
}
customElements.define("sh-dropdown", SHDropdown);
